export default __webpack_public_path__ + "static/media/avatar_elephant5.60d7252c.mp3";